import { Button, Col, Radio, Row, Select } from 'antd';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import styled from 'styled-components';
import { Months } from '../../models';
import { ConsultaStore } from '../../stores/consultaStore';

const ConsultasWrapper = styled.div`
    margin: 80px;
    max-width: 1600px;
    .ant-radio-button-wrapper-checked{
        /* background-color: #a8123e!important;
        border-color: #a8123e !important; */
        /* VEDA */
        background-color: #3c3c3b!important;
        border-color: #3c3c3b !important;
    }
`;
const EtiquetaH1 = styled.h1`
    margin-top: 25px;
    font-size: 24px;
`;
const HeaderContainer = styled.div`
    text-align: 'left';
    margin-top: 25px;
    border-bottom: 1px solid #b9b9b9;
`;
const radioStyle = {
    display: 'block',
    height: '30px',
    lineHeight: '30px',
    marginTop: '30px',
    width: '80%'
};
const PageHeader = styled.h1`
    margin-top: 25px;
    font-size: 24px;
`;

const ColMargen = styled(Col)`
    border-left: 1px solid #b9b9b9 !important;
    padding-left: 20px !important ;
`;

interface AnexosInnerProps extends RouteComponentProps {
    consultaStore?: ConsultaStore;
}

@inject('consultaStore')
@observer
class AnexosInner extends React.Component<AnexosInnerProps, {}> {
    state = {
        reinicio: '0'
    };
    async componentDidMount() {
        const { consultaStore } = this.props;
        consultaStore!.inicializarFiltrosAnexo();
        consultaStore!.inicializarFiltroTipoAnexo();
    }
    limpiarSelected() {
        this.setState({ reinicio: 'Seleccione' });
    }
    crearSelectAnios = () => {
        const anios: string[] = [];
        const fecha = new Date();
        for (let i = fecha.getFullYear(); i >= 2019; i--) {
            anios.push(i.toString());
        }
        return (
            <Select defaultValue="Seleccione" style={{ width: '100%' }} onChange={this.changeAnios}>
                {anios.map(value => (
                    <Select.Option key={value}>{value}</Select.Option>
                ))}
            </Select>
        );
    };
    crearSelectAnexos = () => {
        const { consultaStore } = this.props;
        return (
            <Select
                style={{ width: '100%' }}
                onChange={this.changeAnexos}
                value={this.state.reinicio}
            >
                {consultaStore!.listaAnexos.map(anexo => (
                    <Select.Option key={anexo.id}>{anexo.descripcion}</Select.Option>
                ))}
            </Select>
        );
    };

    clickAgua = () => {
        const { consultaStore } = this.props;
        consultaStore!.visibleAnexos = true;
        consultaStore!.visibleAnios = false;
        this.limpiarSelected();
        this.cargarAnexos(1);
    };
    clickPredial = () => {
        const { consultaStore } = this.props;
        consultaStore!.visibleAnexos = true;
        consultaStore!.visibleAnios = false;
        this.limpiarSelected();
        this.cargarAnexos(2);
    };
    cargarAnexos = async (tipo: number) => {
        const { consultaStore } = this.props;
        await consultaStore!.getAnexos(tipo);
    };
    changeAnexos = (value: any) => {
        const { consultaStore } = this.props;
        consultaStore!.visibleAnios = true;
        consultaStore!.filtrosAnexos!.anexo = value;
        this.setState({ reinicio: value });
    };
    changeAnios = (value: any) => {
        const { consultaStore } = this.props;
        consultaStore!.visibleConsultaAnexos = true;
        consultaStore!.filtrosAnexos!.ejercicio = value;
    };

    clickExportar = async () => {
        const { consultaStore } = this.props;
        const response = await consultaStore!.getExcelAnexo();
        const type = 'application/vnd.ms-excel';
        const blob = new Blob([response], { type });
        const fileDownload = require('react-file-download');
        fileDownload(blob, this.generarNombreAnexo() + '.xlsx');
    };

    generarNombreAnexo = () => {
        const { consultaStore } = this.props;
        const descripcion = consultaStore!.listaAnexos.find(
            a => a.id.toString() === consultaStore!.filtrosAnexos.anexo.toString()
        )!.descripcion;            
        let nombreAnexo = '';      
        nombreAnexo = descripcion + ' ';
        const fecha = new Date();
        let fechaString = fecha.getDate() < 10 ? '0' + fecha.getDate() : fecha.getDate().toString();
        fechaString += Months[fecha.getMonth()].substring(0, 3);
        fechaString += fecha.getFullYear();
        let nombre = '';
        nombre =nombreAnexo + consultaStore!.filtrosAnexos!.ejercicio + ' ' + fechaString ;
        return nombre;
    };

    render() {
        const { consultaStore } = this.props;
        const stylePrimary = {
            backgroundColor:'#a8123e', borderColor:'#a8123e'
        };
        const styleVeda = {
            backgroundColor:'#3c3c3b', borderColor:'#3c3c3b'
        };
        return (
            <ConsultasWrapper>
                <Row>
                    <HeaderContainer>
                        <PageHeader>Consulta de Anexos de Cifras de Recaudación</PageHeader>
                    </HeaderContainer>
                </Row>
                <Row style={{ paddingTop: '30px' }}>
                    <Col span={8}>
                        <Row>
                            <EtiquetaH1>Tipo de Anexo</EtiquetaH1>
                        </Row>
                        <Row>
                            <Radio.Group buttonStyle="solid" style={{ width: '100%' }}>
                                <Radio.Button value="1" style={radioStyle} onClick={this.clickPredial}>
                                    Predial
                                </Radio.Button>
                                <Radio.Button
                                    value="2"
                                    style={radioStyle}
                                    onClick={this.clickAgua}
                                >
                                    Agua
                                </Radio.Button>
                            </Radio.Group>
                        </Row>
                    </Col>
                    <ColMargen span={16}>
                        {consultaStore!.visibleAnexos ? (
                            <>
                                <Row>
                                    <EtiquetaH1>Anexo</EtiquetaH1>
                                </Row>
                                <Row>{this.crearSelectAnexos()}</Row>
                            </>
                        ) : null}
                        {consultaStore!.visibleAnios ? (
                            <>
                                <Row>
                                    <EtiquetaH1>Ejercicio</EtiquetaH1>
                                </Row>
                                <Row>
                                    <Col span={12}>{this.crearSelectAnios()}</Col>
                                    <Col span={12} style={{ textAlign: 'center' }}>
                                        {consultaStore!.visibleConsultaAnexos ? (
                                            <Button
                                                icon="download"
                                                type="primary"
                                                onClick={this.clickExportar}
                                                style={styleVeda}
                                            >
                                                Descargar
                                            </Button>
                                        ) : null}
                                    </Col>
                                </Row>
                            </>
                        ) : null}
                    </ColMargen>
                </Row>
            </ConsultasWrapper>
        );
    }
}
export const Anexos = withRouter(AnexosInner);
